import { Auditable } from "interfaces/auditable";

export enum CaseEventType {
  POST = 0,
  DIAGNOSTIC = 1,
  INSPECTION = 2,
  REPAIR = 3
}

export interface CaseEvent extends Auditable {
  id: number;
  date_time: string;
  type: CaseEventType;
  description: string;
  case: number;
  case_severity_type: number | null;
  params?: any;
  recommendation: string;
}
